import { INICIALIZAR } from '../actions';
export default function configLibros() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case INICIALIZAR:
      return action.config.configLibros;

    default:
      return state;
  }
}